export default "__VITE_ASSET__Czq34$OW__"